import { useInterval, useUnmount } from 'ahooks';
import { useLayoutEffect } from 'react';
import { BaseLogger, STRATEGY_TYPE } from '../services/log/baseLogger';

const gifLogger = new BaseLogger(STRATEGY_TYPE.IMG);

enum FromPlatform {
    PC = 1,
    M = 2,
}

interface LoggerParams {
    /** 页面类型 */
    p: string;
    /** 平台 */
    f: FromPlatform;
    /** 课程id */
    gid: string;
    /** 企业id */
    eid: string;
    /** 小节id */
    sid: string;
}

interface IOptions {
    loopTime?: number;
    refreshDeps?: any[];
}

export const useLoopImgLogger = (
    params: Partial<LoggerParams>,
    options: IOptions = {
        loopTime: 15 * 1000,
    },
) => {
    const clear = useInterval(
        () => {
            gifLogger.log(params);
        },
        options.loopTime,
        {
            immediate: true,
        },
    );

    useLayoutEffect(() => {
        // 获取当前页面的querystring
        const currentQueryString = window.location.search;

        if (currentQueryString.indexOf('debug_log=1') < 0) {
            // 解析querystring为对象
            const params = new URLSearchParams(currentQueryString);

            // 添加新的query参数
            params.append('debug_log', '1');

            // 构建新的querystring
            const newQueryString = '?' + params.toString();

            window.history.pushState({}, '', newQueryString);
        }
    }, []);

    useUnmount(clear);

    return clear;
};
